import {assertPartialSchema, createAction, useSelector, v} from '../../../lib'

export enum ConnectivityActionType {
  CONNECTIVITY_SERVICE_UNAVAILABLE_SET = 'CONNECTIVITY_SERVICE_UNAVAILABLE_SET',
}

export interface ConnectivityState {
  // when the backend first looked unreachable, or null once it answers again
  serviceUnavailableAt: number | null
}

export const doCONNECTIVITY_SERVICE_UNAVAILABLE_SET = createAction<{serviceUnavailableAt: number | null}>(
  ConnectivityActionType.CONNECTIVITY_SERVICE_UNAVAILABLE_SET,
)

export const connectivityActionCreators = {
  doCONNECTIVITY_SERVICE_UNAVAILABLE_SET,
}

interface RootState {
  connectivity: ConnectivityState
}

export const selectConnectivityState = () => {
  return useSelector((state: RootState) => state.connectivity)
}

// deliberately never persisted: a reload should re-discover the backend, not remember an outage
export const connectivityDefaultState: ConnectivityState = {
  serviceUnavailableAt: null,
}

type Action = {
  type: ConnectivityActionType.CONNECTIVITY_SERVICE_UNAVAILABLE_SET
  payload: {serviceUnavailableAt: number | null}
}

export const connectivityReducer = (
  state: ConnectivityState = {...connectivityDefaultState},
  {type, payload}: Action,
): ConnectivityState => {
  switch (type) {
    case ConnectivityActionType.CONNECTIVITY_SERVICE_UNAVAILABLE_SET:
      assertPartialSchema({
        payload,
        schema: v.object({
          serviceUnavailableAt: v.number().allow(null).exist(),
        }),
      })

      return {...state, serviceUnavailableAt: payload.serviceUnavailableAt}

    default:
      return state
  }
}
